/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TransactionSimpleDto { 
    id?: number;
    insertTs: string;
    amount?: number;
    currency?: TransactionSimpleDto.CurrencyEnum;
    transactionDate?: string;
    description: string;
    exchangeRateFromBaseToCurrency?: number;
    baseCurrency?: TransactionSimpleDto.BaseCurrencyEnum;
}
export namespace TransactionSimpleDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
    export const BaseCurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type BaseCurrencyEnum = typeof BaseCurrencyEnum[keyof typeof BaseCurrencyEnum];
}


export type BaseCurrencyEnum = typeof TransactionSimpleDto.BaseCurrencyEnum[keyof typeof TransactionSimpleDto.BaseCurrencyEnum];
